<template>
  <a-modal v-model="visible" title="个人中心" width="720px">
    <template slot="footer">
      <a-button key="submit" type="primary" :loading="loading" @click="modifyPersonal"> 保存 </a-button>
    </template>
    <a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="偏好质量" extra="选择后，后续新建提审单时会自动填入您偏好的质量人员">
        <a-select v-model="form.target_list" mode="multiple" allow-clear placeholder="请选择您偏好的质量人员">
          <a-select-option v-for="qa in qa_list" :key="qa.id" :value="qa.id">{{ qa.nickname }} </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="是否开启自动填入">
        <a-radio-group v-model="form.auto_user" button-style="solid">
          <a-radio-button value="1">是</a-radio-button>
          <a-radio-button value="0">否</a-radio-button>
        </a-radio-group>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script lang="ts">
import { modifyPersonalInfo, getPersonalInfo, userRoleList } from '@/api/system/auth';
export default {
  data() {
    return {
      qa_list: [],
      visible: false,
      loading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      form: {
        auto_user: '0',
        target_list: []
      }
    };
  },
  methods: {
    onOpen() {
      this.visible = true;
      this.getUserList();
      this.getPersonal();
    },

    getUserList() {
      userRoleList({ role_id: 173 }).then(res => {
        this.qa_list = res.data.items;
      });
    },

    getPersonal() {
      getPersonalInfo({}).then(res => {
        this.form.target_list = res.data.qa_list;
        this.form.auto_user = String(res.data.auto_use);
      });
    },

    modifyPersonal() {
      this.loading = true;
      modifyPersonalInfo({
        qa_list: this.form.target_list,
        auto_use: this.form.auto_user
      }).then(() => {
        this.loading = false;
        this.visible = false;
      });
    }
  }
};
</script>
